import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * WS-DBM Phase 3 — first-run temple registration (backend `/bootstrap/**`).
 *
 * Both endpoints are `permitAll` on the server because a fresh installation has
 * no user yet; the server refuses to register once a temple row exists, so the
 * window is exactly one registration.
 */
export interface TempleRegistrationStatus {
  registered: boolean;
  templeId?: number;
  code?: string;
  /** Both the cloud URL and the shared secret are configured on the server. */
  cloudConfigured: boolean;
}

export interface TempleRegistrationPayload {
  name: string;
  nameShort?: string;
  mainDeity?: string;
  address1?: string;
  address2?: string;
  post?: string;
  city?: string;
  district?: string;
  state?: string;
  country?: string;
  pincode?: string;
  mobile?: string;
  phone?: string;
  email?: string;
  isOnline?: boolean;
  admin: {
    userName: string;
    /**
     * NOT sent (owner directive 2026-07-31): the server generates a 6-digit
     * temporary password and has the cloud WhatsApp it to `mobile`.
     */
    firstName?: string;
    lastName?: string;
    phoneNo?: string;
    email?: string;
  };
  config?: {
    financialYearStart?: string;
    dateFormat?: string;
    currency?: string;
    /** Installation default language (english|malayalam|tamil|kannada). */
    language?: string;
    poojaRowLength?: number;
    reportStyle?: string;
    templeEmail?: string;
    stockAndInventory?: boolean;
    showInReports?: boolean;
  };
}

export interface TempleRegistrationResult {
  templeId: number;
  code: string;
  tuid: string;
  userName: string;
}

@Injectable({ providedIn: 'root' })
export class TempleRegistrationService {

  constructor(private http: HttpClient) { }

  getStatus(): Observable<any> {
    return this.http.get<any>('bootstrap/status');
  }

  register(payload: TempleRegistrationPayload): Observable<any> {
    return this.http.post<any>('bootstrap/register-temple', payload);
  }
}
